import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';

import MiniSocketListener from 'FRONTEND/components/MiniSocketListener/MiniSocketListener';
import { CONSULTATION_CREATE_NOTIFICATION } from 'LEGACY/constants';

/**
 * (if not other RTC iframe) Insert an invisible RTC iframe into the DOM and listen to postMessages from it.
 * A callback may be used to react to postMessages them specifically.
 **/
const ConsultationEventListener = ({ signalingUrl, debug = false, onNewConsultationEvent }) => {
  // The RTC message carries the numeric consultation id, which canonical parsys_id URLs do not expose.
  // ConsultationNav (our only parent) dispatches consultationRead on mount, so we read it from the store instead.
  const consultationId = useSelector((state) => state.consultation.currentConsultation.id);

  const eventFilter = useCallback((event) => {
    const message = event.data;
    return (
      message.type === CONSULTATION_CREATE_NOTIFICATION &&
      consultationId != null &&
      String(consultationId) === String(message?.body?.consultation?.id)
    );
  }, [consultationId]);

  return (
    <MiniSocketListener
      signalingUrl={signalingUrl}
      onMessage={onNewConsultationEvent}
      messageFilter={eventFilter}
    />
  );
};


export default ConsultationEventListener;
